<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <!-- HEADING & CATEGORY SELECT -->
  <section>
    <ion-row class="listing-header ion-align-items-center">
      <ion-col class="ion-no-padding">
        <ion-text color="dark">
          <h1 class="h2 page-title">GIVE US A CALL</h1>
        </ion-text>
      </ion-col>
    </ion-row>
  </section>

  <!-- MAP & VISITOR INFORMATION -->
  <ion-grid>
    <ion-row class="contact-details">
      <ion-col size="12" size-lg="7">
        <div *ngIf="apiLoaded | async">
          <google-map [options]="mapOptions">
            <map-marker
              [position]="markerPosition"
              [options]="markerOptions"
              (mapClick)="presentPopover($event)"
            ></map-marker>
          </google-map>
        </div>
      </ion-col>
      <ion-col size="12" size-lg="5">
        <!-- OPENING TIMES -->
        <ion-text color="tertiary">
          <h2 class="opening-times">
            CENTRE | {{visitorInformationOpeningTimes | uppercase}}
          </h2>
        </ion-text>

        <!-- VISITOR INFORMATION -->
        <app-contact-list
          [node]="{title: 'Visitor Information Centre', items: visitorInformation}"
          [withSubject]="true"
        ></app-contact-list>

        <!-- OPENING TIMES -->
        <ion-text color="tertiary">
          <h2 class="opening-times">
            MANAGEMENT OFFICE | {{managementOfficeOpeningTimes | uppercase}}
          </h2>
        </ion-text>

        <!-- VISITOR INFORMATION -->
        <app-contact-list
          [node]="{title: 'Centre Management', items: centreManagement}"
          [withSubject]="true"
        ></app-contact-list>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <!-- Form -->
        <app-form
          [publicForm]="true"
          [node]="{embed: contactFormEmbedTemp}"
        ></app-form>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
